import { FormattedMessage } from 'react-intl';
import StepItem from '../stepItem/StepItem';
import messages from './DebitCardAction.messages';
import { Dispatch } from 'redux';
import { FUNDING_STEP_ACTION } from '../../Funding.actions';
import { connect } from 'react-redux';
import { FundingStepActionButton } from '../fundingStepActionButton/FundingStepActionButton';
import { TFundingRequirementsSteps } from '../orderFundingRequirements';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    handleFundingStepAction: () => {
        dispatch({ type: FUNDING_STEP_ACTION, step: 'DEBIT_CARD' });
    }
});

const DebitCardAction = ({
    status,
    handleFundingStepAction
}: {
    status: TFundingRequirementsSteps['0']['status'];
} & ReturnType<typeof mapDispatchToProps>) => {
    return (
        <StepItem
            title={<FormattedMessage {...messages.title} />}
            caption={<FormattedMessage {...messages.caption} />}
            action={
                <FundingStepActionButton
                    actionMessage={<FormattedMessage {...messages.action} />}
                    pendingMessage={<FormattedMessage {...messages.pending} />}
                    status={status}
                    handleFundingStepAction={handleFundingStepAction}
                />
            }
        />
    );
};
// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(DebitCardAction);
